import defaultLogo from "../../assets/images/defaultLogo.png";
import { COPYRIGHT_MESSAGE } from "constants";
import { Typography } from "@mui/material";
import chroma from "chroma-js";

/**
 * Not found page for end users of the survey.
 * Needed since the regular not found page has the hud ui and uses the login session.
 * @param {object} props
 * @param {object} props.themeColors The theme colors for the survey.
 * @returns {JSX.Element}
 */
const SurveyPageNotFoundContainer = ({ themeColors, children }) => {
    const copyrightTextColor = chroma(themeColors?.secondaryColor).luminance() < 0.33 ? "white" : "black";

    return (
        <div
            style={{
                backgroundColor: themeColors?.primaryColor,
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", // Centers horizontally
                alignItems: "center", // Centers vertically
            }}
        >
            {/* Logo */}
            <div
                className="px-5 md:px-20"
                style={{
                    paddingTop: "3.35rem",
                    width: "100%",
                }}
            >
                <img src={themeColors.mainLogo || defaultLogo} alt="" />
            </div>

            {/* Main Content */}
            {children}

            {/* Flexible Spacing */}
            <span style={{ flex: 1, maxHeight: "64px", minHeight: "12px" }} />

            {/* Footer */}
            <div
                style={{
                    width: "100%",
                    maxHeight: "64px",
                    flexGrow: 1,
                    background: themeColors?.secondaryColor,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {/* todo: this styling is copied from SurveyResults, which is why its not updated to use shared frontend styles */}
                <Typography sx={{ fontWeight: 400, fontSize: 14.02, color: copyrightTextColor }}>
                    {COPYRIGHT_MESSAGE}
                </Typography>
            </div>
        </div>
    );
};

export default SurveyPageNotFoundContainer;
